import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper } from "../../../../../../../../../react-core/Helpers/StringHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { MoneyInTransactionSummary } from "../../../../../../../../../Wrap/Models/Domains/Transactions/Summary/MoneyInTransactionSummary";
import { Table } from "../../../../../../../../Shared/Table/Table";

interface IMoneyInTableProps {
    data: Array<MoneyInTransactionSummary>;
}

export const PaymentsInTable = (props: IMoneyInTableProps) => {
    const stringHelper = new StringHelper();
    return (
        <div>
            <Table
                data={props.data}
                rowCssWrapper={"product-heading"}
                col={[
                    {
                        title: "Product",
                        key: "ClAccountId",
                        render: (data, row, index) => {
                            return (
                                <>
                                    <span
                                        aria-hidden="true"
                                        className={"product-legend " + stringHelper.getDonutClass(row.ProductType, row.WrapperSubType)}
                                    ></span>
                                    <span className={stringHelper.getDonutClass(row.ProductType, row.WrapperSubType) + "-text"}>
                                        {row.ProductDisplayName}
                                    </span>
                                    <span className="account">{data}</span>
                                </>
                            );
                        },
                    },
                    {
                        title: "Regular payment",
                        key: "RegularPaymentAmount",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data + row.RegularPaymentTaxReliefAmount, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                    },
                    {
                        title: "Single payment",
                        key: "SinglePaymentAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: row.SinglePaymentAmount + row.TaxReliefAmount - row.RegularPaymentTaxReliefAmount, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Transfer",
                        key: "TransferAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Total",
                        key: "SurrenderAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                {
                                    Amount:
                                        row.RegularPaymentAmount +
                                        row.SinglePaymentAmount +
                                        row.TransferAmount +
                                        row.TaxReliefAmount,
                                    Currency: CurrencyCode.GBP,
                                },
                                "-",
                                true
                            );
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Portfolio total" },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.RegularPaymentAmount + ele.RegularPaymentTaxReliefAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.SinglePaymentAmount + ele.TaxReliefAmount - ele.RegularPaymentTaxReliefAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.TransferAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return (
                                        total +
                                        ele.RegularPaymentAmount +
                                        ele.SinglePaymentAmount +
                                        ele.TransferAmount +
                                        ele.TaxReliefAmount
                                    );
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            ></Table>
        </div>
    );
};
